export default "__VITE_ASSET__75Lu1vMd__"